const pianoVoice = {
  //Salamander Grand Piano V2
  //Yamaha C5
  A0: "/audio/salamander/A0.mp3",
  C1: "/audio/salamander/C1.mp3",
  "D#1": "/audio/salamander/Ds1.mp3",
  "F#1": "/audio/salamander/Fs1.mp3",
  A1: "/audio/salamander/A1.mp3",
  C2: "/audio/salamander/C2.mp3",
  "D#2": "/audio/salamander/Ds2.mp3",
  "F#2": "/audio/salamander/Fs2.mp3",
  A2: "/audio/salamander/A2.mp3",
  C3: "/audio/salamander/C3.mp3",
  "D#3": "/audio/salamander/Ds3.mp3",
  "F#3": "/audio/salamander/Fs3.mp3",
  A3: "/audio/salamander/A3.mp3",
  C4: "/audio/salamander/C4.mp3",
  "D#4": "/audio/salamander/Ds4.mp3",
  "F#4": "/audio/salamander/Fs4.mp3",
  A4: "/audio/salamander/A4.mp3",
  C5: "/audio/salamander/C5.mp3",
  "D#5": "/audio/salamander/Ds5.mp3",
  "F#5": "/audio/salamander/Fs5.mp3",
  A5: "/audio/salamander/A5.mp3",
  C6: "/audio/salamander/C6.mp3",
  "D#6": "/audio/salamander/Ds6.mp3",
  "F#6": "/audio/salamander/Fs6.mp3",
  A6: "/audio/salamander/A6.mp3",
  C7: "/audio/salamander/C7.mp3",
  "D#7": "/audio/salamander/Ds7.mp3",
  "F#7": "/audio/salamander/Fs7.mp3",
  A7: "/audio/salamander/A7.mp3",
  C8: "/audio/salamander/C8.mp3",
};

const motifPiano = {
  // Motif | Full Concert Grand
  A0: "/audio/motif/21.wav",
  B0: "/audio/motif/23.wav",
  D1: "/audio/motif/26.wav",
  F1: "/audio/motif/29.wav",
  "G#1": "/audio/motif/32.wav",

  B1: "/audio/motif/35.wav",
  D2: "/audio/motif/38.wav",
  F2: "/audio/motif/41.wav",
  "G#2": "/audio/motif/44.wav",
  B2: "/audio/motif/47.wav",

  D3: "/audio/motif/50.wav",
  F3: "/audio/motif/53.wav",
  G3: "/audio/motif/55.wav",
  "A#3": "/audio/motif/58.wav",
  C4: "/audio/motif/60.wav",

  D4: "/audio/motif/62.wav",
  F4: "/audio/motif/65.wav",
  "G#4": "/audio/motif/68.wav",
  "A#4": "/audio/motif/70.wav",
  C5: "/audio/motif/72.wav",

  D5: "/audio/motif/74.wav",
  "F#5": "/audio/motif/78.wav",
  "G#5": "/audio/motif/80.wav",
  B5: "/audio/motif/83.wav",
  C6: "/audio/motif/84.wav",

  D6: "/audio/motif/86.wav",
  "D#6": "/audio/motif/87.wav",
  F6: "/audio/motif/89.wav",
  "G#6": "/audio/motif/92.wav",
  B6: "/audio/motif/95.wav",

  D7: "/audio/motif/98.wav",
  F7: "/audio/motif/101.wav",
  "G#7": "/audio/motif/104.wav",
  B7: "/audio/motif/107.wav",
};

const bassVoice = {
  "A#1": "/audio/bass-electric/As1.mp3",
  "A#2": "/audio/bass-electric/As2.mp3",
  "A#3": "/audio/bass-electric/As3.mp3",
  "A#4": "/audio/bass-electric/As4.mp3",
  "C#1": "/audio/bass-electric/Cs1.mp3",
  "C#2": "/audio/bass-electric/Cs2.mp3",
  "C#3": "/audio/bass-electric/Cs3.mp3",
  "C#4": "/audio/bass-electric/Cs4.mp3",
  "C#5": "/audio/bass-electric/Cs5.mp3",
  E1: "/audio/bass-electric/E1.mp3",
  E2: "/audio/bass-electric/E2.mp3",
  E3: "/audio/bass-electric/E3.mp3",
  E4: "/audio/bass-electric/E4.mp3",
  G1: "/audio/bass-electric/G1.mp3",
  G2: "/audio/bass-electric/G2.mp3",
  G3: "/audio/bass-electric/G3.mp3",
  G4: "/audio/bass-electric/G4.mp3",
};

const pianoNoireVoice = {
  // Noire Pure
  A1: "/audio/NoirePure/A0.wav",
  A2: "/audio/NoirePure/A1.wav",
  A3: "/audio/NoirePure/A2.wav",
  A4: "/audio/NoirePure/A3.wav",
  A5: "/audio/NoirePure/A4.wav",
  A6: "/audio/NoirePure/A5.wav",
  C2: "/audio/NoirePure/C1.wav",
  C3: "/audio/NoirePure/C2.wav",
  C4: "/audio/NoirePure/C3.wav",
  C5: "/audio/NoirePure/C4.wav",
  C6: "/audio/NoirePure/C5.wav",
  C7: "/audio/NoirePure/C6.wav",
  E2: "/audio/NoirePure/E1.wav",
  E3: "/audio/NoirePure/E2.wav",
  E4: "/audio/NoirePure/E3.wav",
  E5: "/audio/NoirePure/E4.wav",
  E6: "/audio/NoirePure/E5.wav",
};

const bassLiverPoolVoice = {
  // Liverpool
  A2: "/audio/LiverpoolBass/A1.wav",
  A3: "/audio/LiverpoolBass/A2.wav",
  C3: "/audio/LiverpoolBass/C2.wav",
  C4: "/audio/LiverpoolBass/C3.wav",
  D3: "/audio/LiverpoolBass/D2.wav",
  D4: "/audio/LiverpoolBass/D3.wav",
  E2: "/audio/LiverpoolBass/E1.wav",
  E3: "/audio/LiverpoolBass/E2.wav",
  E4: "/audio/LiverpoolBass/E3.wav",
  F3: "/audio/LiverpoolBass/F2.wav",
  F4: "/audio/LiverpoolBass/F3.wav",
  G2: "/audio/LiverpoolBass/G1.wav",
  G3: "/audio/LiverpoolBass/G2.wav",
  G4: "/audio/LiverpoolBass/G3.wav",
};

export {
  pianoVoice,
  motifPiano,
  bassVoice,
  pianoNoireVoice,
  bassLiverPoolVoice,
};
